import { z } from 'zod';

export const completeClipUploadResponseSchema = z.object({
  success: z.boolean(),
});

export type ICompleteClipUploadResponse = z.infer<typeof completeClipUploadResponseSchema>;
